import {
  GIF_MAX_DURATION_MS,
  GIF_MAX_FRAMES,
  GIF_MAX_LONGEST_EDGE,
  GIF_MAX_PIXELS,
} from '../constants';
import { ConversionError } from '../lib/errors';
import type { GifMetadata } from '../lib/gif-metadata';

export function enforceAnimatedGifLimits(metadata: GifMetadata): void {
  if (metadata.frameCount > GIF_MAX_FRAMES) {
    throw new ConversionError(
      'gif-too-many-frames',
      `Animated GIFs are limited to ${GIF_MAX_FRAMES} source frames.`,
    );
  }
  if (metadata.normalizedDurationMs > GIF_MAX_DURATION_MS) {
    throw new ConversionError('gif-too-long', 'Animated GIFs are limited to 10 seconds.');
  }
  if (
    Math.max(metadata.width, metadata.height) > GIF_MAX_LONGEST_EDGE ||
    metadata.width * metadata.height > GIF_MAX_PIXELS
  ) {
    throw new ConversionError(
      'gif-dimensions-too-large',
      'Animated GIFs are limited to 1024 pixels on the longest edge and one megapixel per frame.',
    );
  }
}
